import { MenuType } from '@shared/interfaces/menu/menuType.interface';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from './menu.service';
import { FooterLinkColumns } from '@shared/interfaces/footer-link-columns.interface';

@Injectable({
  providedIn: 'root',
})
export class FooterContentService {
  constructor(public menuService: MenuService, public router: Router) {}

  private footerType() {
    var menuType = MenuType.Default;
    if (this.menuService.isUkraineUrl()) {
      menuType = MenuType.HelpUkraine;
    }
    if (this.menuService.isWcd()) {
      menuType = MenuType.WorldCleanupDay;
    }
    return menuType;
  }

  loadFooterContent() {
    var footerColumns: FooterLinkColumns[] = [];
    switch (this.footerType()) {
      case MenuType.HelpUkraine:
        footerColumns = this.loadUa();
        break;
      case MenuType.WorldCleanupDay:
        footerColumns = this.loadWCD();
        break;
      default:
        footerColumns = this.loadStandard();
        break;
    }
    return footerColumns;
  }

  private loadStandard() {
    return [
      {
        label: 'menu',
        links: [
          'projects/verified',
          'ranking',
          'articles/how-it-works',
          'projects/ended',
          'ambassador',
        ],
      },
      {
        label: 'planet_heroes',
        links: ['about', 'contact_us', 'enquiries', 'faq'],
      },
      {
        label: 'blog',
        links: [
          '/articles/common/skutecznie-posprzatane',
          '/articles/common/world_cleanup_day',
          '/articles/common/plogging',
          'articles/common/invento',
          '/articles/common/planet-heroes-awarded-at-the-united-nations-forum-in-nairobi',
        ],
      },
      {
        label: 'contact',
        links: ['support@planetheroes.app'],
      },
    ];
  }

  private loadUa() {
    return [
      {
        label: 'menu',
        links: ['articles/how-it-works', 'helpukraine-faq'],
      },
      {
        label: 'planet_heroes',
        links: ['contact_us', 'about-help-ukraine'],
      },
      {
        label: 'blog',
        links: ['articles/common/help-ukraine'],
      },
      {
        label: 'contact',
        links: ['support@planetheroes.app'],
      },
    ];
  }

  private loadWCD() {
    return [
      {
        label: 'menu',
        links: ['articles/how-it-works', 'events/verified', 'projects/verified'],
      },
      {
        label: 'planet_heroes',
        links: ['contact_us'],
      },
    ];
  }
}
